(function () {
  const button = document.getElementById('scroll-to-top');
  if (!button) return;

  const fill = button.querySelector('.scroll-to-top__paw--fill');
  const SHOW_AFTER_PX = 600;
  let ticking = false;
  let footerVisible = false;

  const update = () => {
    const scrollable = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const progress = scrollable > 0 ? Math.min(100, Math.max(0, (window.scrollY / scrollable) * 100)) : 0;

    fill.style.setProperty('--scroll-progress', `${progress}%`);
    button.classList.toggle('scroll-to-top--visible', window.scrollY > SHOW_AFTER_PX && !footerVisible);
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  button.hidden = false;
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  const footer = document.querySelector('.footer');
  if (footer) {
    new IntersectionObserver(
      (entries) => {
        footerVisible = entries[0].isIntersecting;
        requestUpdate();
      },
      { threshold: 0 }
    ).observe(footer);
  }

  update();

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
